import { useTranslation } from "react-i18next"
import { useAuth } from "../../contexts/authContext"

export default function Footer() {
  const { t } = useTranslation()
  const { isAuthenticated } = useAuth()
  const links = [
    { name: t("headerHome"), href: '/' },
    { name: t("headerAbout"), href: '/#about' },
    { name: t("headerPricing"), href: '/#pricing' },
    { name: t("headerFaq"), href: '/#faq' },
    { name: t("headerGuide"), href: '/pages/guide' },
    { name: t("contactButton"), href: `mailto:${t("contactEmail")}` },
    { name: t("termsButton"), href: '/terms' },
  ]

  return (
    <section className="mt-8 bg-ink px-6 pt-24 lg:px-16">
      <div className="mx-auto flex max-w-[1152px] flex-col gap-16">
        {/* CTA */}
        <div className="flex flex-col items-center gap-6 text-center">
          <h2 className="max-w-[640px] text-4xl font-bold leading-tight tracking-[-1px] text-cream sm:text-[44px]">
            {t("footerCtaTitle")}
          </h2>
          <a
            href={isAuthenticated ? t("loginLink") : t("signupLink")}
            className="ds-cta h-14 px-9 text-base"
          >
            {isAuthenticated ? t("goToApp") : t("startBtn")}
          </a>
          <span className="text-[13px] font-medium text-[#C9B8A6]">{t("footerCtaSubtext")}</span>
        </div>

        {/* Bottom row */}
        <div className="flex flex-col items-center justify-between gap-4 border-t border-white/10 py-8 md:flex-row">
          <nav className="flex flex-wrap justify-center gap-x-6 gap-y-3">
            {links.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="text-[13px] font-medium text-[#C9B8A6] transition-colors hover:text-white"
              >
                {item.name}
              </a>
            ))}
          </nav>
          <span className="text-center text-[13px] font-medium text-muted">
            &copy; 2026 {t("address")} ·{" "}
            <a
              href="https://w2.brreg.no/enhet/sok/detalj.jsp?orgnr=932761173"
              target="_blank"
              rel="noreferrer"
              className="hover:text-white"
            >
              Magnus Heide AS
            </a>
          </span>
        </div>
      </div>
    </section>
  )
}
